import type { ApiErrorDetail } from 'common/models';
import Alert from 'components/Alert/Alert';
import ErrorMessage from 'components/ErrorAlert/ErrorMessage';
import type { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';

interface RootErrorTypes {
  detail?: string;
  traceId?: string;
  errorCode?: string;
  errorMessage?: string;
  title?: string;
}

const FormError = ({ description }: { description?: ReactNode }) => {
  const {
    formState: { errors }
  } = useFormContext();

  if (!errors.root) {
    return <div />;
  }

  const rootErrorTypes = (errors.root.types ?? {}) as RootErrorTypes;
  const detail = rootErrorTypes.detail;
  const traceId = rootErrorTypes.traceId;
  const errorCode = rootErrorTypes.errorCode;
  const title = rootErrorTypes.title;
  const errorMessage = rootErrorTypes.errorMessage;

  if (detail || traceId || errorCode || errorMessage || title) {
    const errorDetail: ApiErrorDetail = {
      title: (title as string) || 'Error',
      errorCode: (errorCode as string) || null,
      errorMessage: errorMessage || errors.root.message,
      detail: (detail as string) || '',
      status: 0,
      traceId: (traceId as string) || '',
      spanId: ''
    };

    return (
      <Alert
        className="ErrorAlert"
        message={<ErrorMessage error={errorDetail} />}
        description={description}
        type="error"
      />
    );
  }

  return (
    errors.root && (
      <Alert
        className="ErrorAlert"
        message={errors.root.message}
        description={description}
        type="error"
      />
    )
  );
};

export default FormError;
